import React, { FC, useState } from 'react'

import { EuiPanel, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiButtonIcon, EuiBadge, EuiText, EuiToolTip } from '@elastic/eui'

import { Persona } from 'api/interfaces/Persona'
import AgencyV2Modal from 'features/planner/components/AgencyV2Modal'
import SparklesIcon from 'features/planner/components/SparklesIcon'

import PersonaDetails from './PersonaDetails'
import PersonaHeader from './PersonaHeader'

export interface PersonaCardProps {
  persona: Persona
  isExpanded: boolean
  onToggle: () => void
  onEditClick?: () => void
  onAIEditClick?: () => void
  onDeleteClick?: () => Promise<void>
  onDeleteLoading?: boolean
  showActions?: boolean
}

const PersonaCard: FC<PersonaCardProps> = ({ persona, isExpanded, onToggle, onEditClick, onAIEditClick, onDeleteClick, onDeleteLoading = false, showActions = true }) => {
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false)

  const handleDeleteClick = () => {
    setIsDeleteModalVisible(true)
  }

  const onConfirmDeleteClick = async () => {
    await onDeleteClick?.()
    setIsDeleteModalVisible(false)
  }

  return (
    <>
      <EuiPanel paddingSize='l'>
        <EuiFlexGroup>
          <EuiFlexItem grow={false} style={{ marginLeft: '-28px' }}>
            <EuiBadge
              style={{
                backgroundColor: '#f5f5f5',
                color: 'black',
                margin: 'auto',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontWeight: 'bold',
                fontSize: '14px'
              }}>
              {persona.rank}
            </EuiBadge>
          </EuiFlexItem>
          <EuiFlexItem style={{ marginLeft: '1rem' }}>
            <EuiFlexGroup alignItems='center' justifyContent='spaceBetween' responsive={false}>
              <EuiFlexItem>
                <PersonaHeader persona={persona} />
              </EuiFlexItem>
              {showActions && (
                <EuiFlexItem grow={false}>
                  <EuiFlexGroup gutterSize='xs' responsive={false}>
                    <EuiFlexItem grow={false}>
                      <EuiToolTip content="Manual Edit">
                        <EuiButtonIcon iconType='pencil' style={{ color: '#0071c2' }} onClick={onEditClick} aria-label={`Manual Edit ${persona.name}`} size='s' />
                      </EuiToolTip>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                      <EuiToolTip content="AI Edit">
                        <EuiButtonIcon iconType={SparklesIcon} onClick={onAIEditClick} aria-label={`AI Edit ${persona.name}`} size='s' />
                      </EuiToolTip>
                    </EuiFlexItem>
                    <EuiFlexItem grow={false}>
                      <EuiToolTip content="Delete Persona">
                        <EuiButtonIcon iconType='trash' style={{ color: '#BD271E' }} onClick={handleDeleteClick} aria-label={`Delete ${persona.name}`} size='s' />
                      </EuiToolTip>
                    </EuiFlexItem>
                  </EuiFlexGroup>
                </EuiFlexItem>
              )}
            </EuiFlexGroup>

            <EuiSpacer size='m' />

            {isExpanded && <PersonaDetails persona={persona} />}
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPanel>
      {isDeleteModalVisible && (
        <AgencyV2Modal isLoading={onDeleteLoading} title='Remove Persona' onClose={() => setIsDeleteModalVisible(false)} confirmButtonText='Remove' onConfirmButtonClick={onConfirmDeleteClick} showCancelButton>
          <EuiText>
            Persona: <strong>{persona.name}</strong> will be removed from the plan.
          </EuiText>
        </AgencyV2Modal>
      )}
    </>
  )
}

export default PersonaCard
